import React, { Component } from 'react'
import { Navigate, Route, Routes } from 'react-router'

import RedirectToApps from '../components/Apps/RedirectToApps'
import NotFound from '../components/Error/NotFound'
import Pages from '../components/Pages/Pages'
import { ROUTES } from '../routes/Routes.config'

class Layout extends Component {
  render() {
    let routes = (
      <Routes>
        <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
        <Route path={ROUTES.GET_APP} element={<RedirectToApps />} />
        <Route path={ROUTES.ORGANIZATION_LEVEL_PAGES} element={<Pages />} />
        <Route path={ROUTES.PROGRAM_LEVEL_PAGES} element={<Pages />} />
        <Route path="*" element={<Navigate to={ROUTES.NOT_FOUND} replace />} />
      </Routes>
    )
    return routes
  }
}

export default Layout
